import React from 'react';
import PropTypes from 'prop-types';

// Assets
import {greyishBlue500} from "assets/jss/main";

ActionLink.propTypes = {
    onClick: PropTypes.func.isRequired,
};

function ActionLink({onClick, ...props}) {
    return (
        <u
            onClick={onClick}
            style={{
                color: greyishBlue500,
                cursor: 'pointer',
            }}
        >
            {props.children}
        </u>
    );
}

export default ActionLink;
